module.exports = __webpack_public_path__ + "img/binding1.5bc0fd06.jpg";